import { Idle } from "../../../../../../../types/service/dashboard/IWorksDashboardService";
import { useMemo } from "react";
import { isUndefined } from "lodash";

export const useMergedIdles = (arr1: Idle[], arr2: Idle[]): Idle[] => {
    return useMemo(() => {
        const typeOfIdleMap = arr1.concat(arr2).reduce((map, idle) => {
            const { typeOfIdle = "" } = idle;
            const existingIdle = map.get(typeOfIdle) || {
                typeOfIdle,
                plan: 0,
                fact: 0,
                color: idle.color,
                id: idle.id,
            };

            if (!isUndefined(existingIdle.plan)) existingIdle.plan += idle.plan || 0;
            if (!isUndefined(existingIdle.fact)) existingIdle.fact += idle.fact || 0;

            map.set(typeOfIdle, existingIdle);
            return map;
        }, new Map<string, Idle>());

        return Array.from(typeOfIdleMap.values());
    }, [arr1, arr2]);
};